var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var IntlProvider = ReactIntl.IntlProvider;
var defaultMessages = require('../../i18n/messages/default');
var AppConstants = require('../../constants/AppConstants');
var PasswordField = require('../Password/PasswordField');
var Footer = require('../Footer/Footer');
var Header = require('../Header/Header');
var LoginActions = require('../../actions/LoginActions');
var LoginStore = require('../../stores/LoginStore');
var ErrorCodes = require('../../utils/ErrorCodes.js');
var PageCase = require('../PageCase/PageCase.js');
var createReactClass = require('create-react-class');
var { Input, Button } = require('metro-ui-components');
var InputMask = require('react-input-mask');
var Utils = require('../../utils/Utils');

var ChangePassword = createReactClass({
    displayName: 'ChangePassword',
    currentPassword: '',
    newPassword: '',

    getInitialState() {
        const countryCodes = AppConstants.COUNTRY_CODE_FOR_NUMBERS[this.props.countryCode] ? 
                                AppConstants.COUNTRY_CODE_FOR_NUMBERS[this.props.countryCode] : AppConstants.COUNTRY_CODE_FOR_NUMBERS[AppConstants.DEFAULT_COUNTRY_CODE];
                                
        return {
            atLeastEightChar: 'defaultFieldColor',
            pwdDoesNotContainSpace: 'defaultFieldColor',
            renderPassCriteria: 'passwordValidationBox',
            inValidatePasswordField: true,
            loginId: this.props.loginId || '',
            isPhoneNumber: false,
            maskedCountryCodePhoneNumber: countryCodes.maskedCountryCodePhoneNumber,
            maskedCountryPhoneNumber: countryCodes.maskedCountryPhoneNumber,
            countryCodePhoneNumber: countryCodes.countryCodePhoneNumber,
            caretPosition: null,
        };
    },

    componentDidMount: function () {
        LoginStore.addChangePasswordChangeListener(this._onChangePasswordChange);
        LoginActions.getUserLoginStrategy(this.props.countryCode, this.props.userType);
    },
    _onChangePasswordChange: function () {
        let appState = LoginStore.getState();
        if (appState.changePasswordCode.status == AppConstants.ApiResponse.SUCCESS) {
            window.location = this.props.redirectUrl + "?status=" + appState.changePasswordCode.status;
        }else {
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.changePasswordCode.errorCode]]), "error")
        }

    },

    renderFooter: function () {
        return (
            <IntlProvider
                locale={this.props.localeId}
                messages={this.props.translations}>
                <Footer {...this.props} locale={this.props.localeId} />
            </IntlProvider>
        )
    },

    onFocusPasswordField: function (e) {
        this.setState({ renderPassCriteria: 'passwordValidationBox showMe' })
    },

    onCurrentPasswordChange: function (password) {
        this.currentPassword = password;
    },

    onNewPasswordChange: function (password) {
        this.newPassword = password;

        let passwordLength = /^.{8,1000}$/;
        let passwordContainSpace = /\s/g;

        if (this.newPassword.length < AppConstants.passwordValidationCriterias.AT_LEAST_EIGHT_CHAR) {
            this.setState({ atLeastEightChar: 'inValidField' });
        } else {
            this.setState({ atLeastEightChar: 'validField' });
        }

        if (this.newPassword.match(/\s/g)) {
            this.setState({ pwdDoesNotContainSpace: 'invalidField' });
        } else {
            this.setState({ pwdDoesNotContainSpace: 'validField' });
        }

        if (passwordLength.test(this.newPassword) && !this.newPassword.match(passwordContainSpace) && this.currentPassword != "") {
            this.setState({ inValidatePasswordField: false });
        } else {
            this.setState({ inValidatePasswordField: true });
        }

    },

    onChangePasswordSubmit: function (evt) {
        evt.preventDefault();
        const errorMessage = this.props.intl.formatMessage(defaultMessages['errorNewPasswordSameAsOld']);
        if (this.currentPassword == this.newPassword) {
            LoginActions.triggerToast(errorMessage, "error")
        } else {
            LoginActions.submitChangePassword(this.loginId || this.state.loginId, this.currentPassword, this.newPassword, this.props.userType);
        }
    },

    onChangePasswordCancel: function (evt) {
        evt.preventDefault();
        document.getElementById("change-password-form").reset();
        this.setState({ renderPassCriteria: 'passwordValidationBox hideMe' });
        this.setState({ inValidatePasswordField: true });
    },

    redirectToVerticalPage: function (evt) {
        evt.preventDefault();
        window.location = this.props.redirectUrl;
    },
    onChangeLoginId(e) {

        var value = e.target.value;
        var caretPosition = this.state.caretPosition

        if (caretPosition && caretPosition > 0) {
            Utils.setCaretPosition("user_id", caretPosition);
            this.setState({ caretPosition: null });
        }

        if (this.props.allowMobileLogin) {
            const regEx = RegExp("^(\\+?)(\\d+)(\\s\\|\\s)\?(\\d*)$", 'g');
            const isPhoneNumber = regEx.test(value);
            if (this.state.isPhoneNumber == true && isPhoneNumber == false) {
                value = value.replace("+", "");
            }

            if (this.state.isPhoneNumber == false && isPhoneNumber == true) {
                if (value && value.indexOf('+') == -1) {
                    value = value.replace("+", "")
                    value = this.state.countryCodePhoneNumber + AppConstants.LOGIN_SEPERATOR + value;
                }
                else {
                    if (value && value.indexOf(AppConstants.LOGIN_SEPERATOR) == -1 && value.length == this.state.countryCodePhoneNumber.length) {
                        value = value.slice(0, this.state.countryCodePhoneNumber.length)
                            + AppConstants.LOGIN_SEPERATOR
                            + txt1.slice(this.state.countryCodePhoneNumber.length);
                    }
                }
            }

            let transformedValue = value;
            if (isPhoneNumber) {
                transformedValue = transformedValue.replace('+', '00');
                transformedValue = transformedValue.replace(AppConstants.LOGIN_SEPERATOR, '');
            }

            this.loginId = transformedValue;
            this.setState({ loginId: value, isPhoneNumber });
        }
        else {
            this.loginId = value.trim();
            this.setState({ loginId: value.trim() });
        }
    },

    setLoginValue(value) {

        const regEx = RegExp("^(\\+?)(\\d+)(\\s\\|\\s)\?(\\d*)$", 'g');
        const isPhoneNumber = regEx.test(value);
        console.log("isPhoneNumber ", isPhoneNumber);

        if (isPhoneNumber == true) {
            if (value && value.indexOf('+') == -1) {
                value = value.replace("+", "")
                value = this.state.countryCodePhoneNumber + AppConstants.LOGIN_SEPERATOR + value;
            }
            else {
                if (value && value.indexOf(AppConstants.LOGIN_SEPERATOR) == -1 && value.length == this.state.countryCodePhoneNumber.length) {
                    value = value.slice(0, this.state.countryCodePhoneNumber.length)
                        + AppConstants.LOGIN_SEPERATOR
                        + txt1.slice(this.state.countryCodePhoneNumber.length);
                }
            }
        }

        let transformedValue = value;
        if (isPhoneNumber) {
            transformedValue = transformedValue.replace('+', '00');
            transformedValue = transformedValue.replace(AppConstants.LOGIN_SEPERATOR, '');
        }

        this.loginId = transformedValue;

        return {
            value: value,
            isPhoneNumber: isPhoneNumber
        };
    },

    beforeMaskedValueChange(newState, oldState, userInput) {
        var { value } = newState;
        var selection = newState.selection;
        var cursorPos = selection ? selection.start : null;

        const regEx = RegExp("^(\\+?)(\\d+)(\\s\\|\\s)\?(\\d*)$", 'g');
        const isNotPhoneNumber = !regEx.test(userInput);

        if (userInput && this.state.isPhoneNumber == true && isNotPhoneNumber == true) { // check and remove occurance of +        
            if (cursorPos > 0)
                value = value.substring(0, cursorPos) + userInput + value.substring(cursorPos, value.length);
            else
                value = userInput + value;

            value = value.split(AppConstants.LOGIN_SEPERATOR).pop();
            var prefixLength = this.state.maskedCountryCodePhoneNumber.length + AppConstants.LOGIN_SEPERATOR.length;
            this.setState({ caretPosition: (cursorPos - prefixLength + 1) });
        }

        return {
            value,
            selection
        };
    },

    renderForm(props) {
        return (
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <form id="change-password-form" onSubmit={this.onChangePasswordSubmit} noValidate="novalidate">
                        <div className="form-group change-password-form">
                            {this.renderUserIdField()}
                            <PasswordField
                                placeholder="Current Password"
                                id="old_password"
                                {...props}
                                onPasswordChange={this.onCurrentPasswordChange} />
                            <PasswordField
                                placeholder="field.password"
                                displayStrength={true}
                                id="new_password"
                                {...props}
                                onFocus={this.onFocusPasswordField}
                                onPasswordChange={this.onNewPasswordChange} />
                            <div className={this.state.renderPassCriteria}>
                                <div className='headingText'>
                                    {this.props.intl.formatMessage(defaultMessages['passwordValidationCriteriaHeader'])}
                                </div>
                                <div className={this.state.atLeastEightChar}>
                                    {this.props.intl.formatMessage(defaultMessages['passwordValidationCriteria1'])}</div>
                                <div className={this.state.pwdDoesNotContainSpace}>
                                    {this.props.intl.formatMessage(defaultMessages['passwordValidationCriteria2'])}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 col-sm-6 col-xs-12 pull-right">
                                    <Button
                                        id="submit"
                                        type="submit"
                                        kind="primaryRaised"
                                        className="submit-btn"
                                        size="large"
                                        value="submit"
                                        block
                                        disabled={this.state.inValidatePasswordField || !(this.state.loginId && this.state.loginId.length > 0)}>
                                        {this.props.intl.formatMessage(defaultMessages['save'])}
                                    </Button>
                                </div>
                                <div className="col-md-6 col-sm-6 col-xs-12 pull-right">
                                    <Button
                                        id="Cancel"
                                        kind="secondary"
                                        className="cancel-btn"
                                        size="large"
                                        value="Cancel"
                                        block
                                        onClick={this.redirectToVerticalPage}>
                                        {this.props.intl.formatMessage(defaultMessages['cancel'])}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    },

    renderUserIdField() {
        let isInputBoxDisabled = false;
        if (this.props.loginId && this.props.loginId.length > 0) {
            isInputBoxDisabled = true;
        }

        var props = this.props;
        if (props.allowMobileLogin) {
            let label = props.intl.formatMessage(defaultMessages['login.link.EmailOrMobile']);
            let maskedCountryCodePhoneNumber = this.state.maskedCountryCodePhoneNumber;
            let maskedCountryPhoneNumber = this.state.maskedCountryPhoneNumber;
            let mask = maskedCountryCodePhoneNumber + AppConstants.LOGIN_SEPERATOR + maskedCountryPhoneNumber;

            var result = isInputBoxDisabled ? this.setLoginValue(this.props.loginId) : {};

            //login_id from url available so disabled the input
            if (isInputBoxDisabled && result.isPhoneNumber) {
                return (
                    <span id='loginIdBox'>
                        <div className="m-input m-input-email_id">
                            <div className="m-label">
                                <label>{label}</label>
                            </div>
                            <div className="m-input-elementWrapper">
                                <InputMask
                                    id="user_id"
                                    name="user_id"
                                    autoComplete="off"
                                    mask={mask}
                                    maskChar={''}
                                    value={result.value}
                                    className="m-input-element"
                                    autoFocus={true}
                                    onChange={this.onChangeLoginId}
                                    disabled={true}
                                    beforeMaskedValueChange={this.beforeMaskedValueChange} />
                            </div></div>
                    </span>
                )

            }
            else if (this.state.isPhoneNumber) {
                return (
                    <span id='loginIdBox'>
                        <div className="m-input m-input-email_id">
                            <div className="m-label">
                                <label>{label}</label>
                            </div>
                            <div className="m-input-elementWrapper">
                                <InputMask
                                    id="user_id"
                                    name="user_id"
                                    autoComplete="off"
                                    mask={mask}
                                    maskChar={''}
                                    value={this.state.loginId}
                                    className="m-input-element"
                                    autoFocus={true}
                                    onChange={this.onChangeLoginId}
                                    disabled={isInputBoxDisabled}
                                    beforeMaskedValueChange={this.beforeMaskedValueChange} />
                            </div></div>
                    </span>
                )
            } else {
                return (
                    <Input
                        id="user_id"
                        type="email"
                        key="user_id"
                        name="user_id"
                        autoComplete="off"
                        label={label}
                        required={true}
                        value={this.state.loginId}
                        onChange={this.onChangeLoginId}
                        onKeyUp={this.onChangeLoginId}
                        onKeyDown={this.onChangeLoginId}
                        autoFocus={true}
                        disabled={isInputBoxDisabled}
                    />
                );
            }
        }

        return (
            <span>
                <Input
                    id="user_id"
                    type="email"
                    key="user_id"
                    name="user_id"
                    autoComplete="off"
                    label={this.props.intl.formatMessage(defaultMessages['userName'])}
                    required={true}
                    value={this.state.loginId}
                    onChange={this.onChangeLoginId}
                    autoFocus={true}
                    disabled={isInputBoxDisabled}
                />
            </span>
        );
    },

    renderContent() {
        let props = this.props;
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 col-sm-2 col-xs-12"></div>
                        <div className="col-md-6 col-sm-8 col-xs-12">
                            <div className="row changePasswordContainer change-password-larger-device">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="changePasswordHeader">
                                            <span>
                                                {this.props.intl.formatMessage(defaultMessages['Change Password'])}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <div className="loginFields change-password-fields">
                                            {this.renderForm(props)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-2 col-xs-12"></div>
                    </div>
                </div>
            </div>
        )
    },
    renderHeader() {
        return (
            <div>
                <Header />
            </div>
        )
    },
    render: function () {
        return (
            <PageCase
                header={this.renderHeader()}
                content={this.renderContent()}
                footer={this.renderFooter()}></PageCase>
        )
    }
});

module.exports = injectIntl(ChangePassword);
